import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import TravellerLayout from "@/components/traveller/TravellerLayout";

export default function FlightLaunchProfile() {
  const { user } = useAuth();
  return <TravellerLayout><section className="mx-auto max-w-xl rounded-3xl border border-[#294F40]/20 bg-[#EEECE4] p-6 text-[#233E34] sm:p-8">
    <p className="text-sm font-semibold text-[#28634D]">Traveller account</p>
    <h1 className="mt-2 text-3xl font-bold">Your profile</h1>
    <dl className="mt-7 space-y-5">
      <div><dt className="text-sm text-[#506458]">Name</dt><dd className="mt-1 font-semibold">{user.full_name}</dd></div>
      <div><dt className="text-sm text-[#506458]">Email</dt><dd className="mt-1 break-words">{user.email || "Not added"}</dd></div>
      <div><dt className="text-sm text-[#506458]">Phone</dt><dd className="mt-1">{user.phone || "Not added"}</dd></div>
    </dl>
    <Link to="/account/settings" className="mt-8 inline-flex rounded-full bg-[#28634D] px-5 py-3 font-semibold text-[#F7F5ED]">Manage sign-in details</Link>
  </section></TravellerLayout>;
}
